import React, { useEffect, useRef, useState } from 'react';
import bestWinIcon from '../static/img/icon-section/best-win.png';
import providerIcon from '../static/img/icon-provider/1x2gaming-icon.png';
import slideImg1 from '../static/img/slide-1.jpg';

import Game from '../../../class/Game/Game.js';
import Games from '../../../class/Game_copy/Game.js';
import AuthService from '../../../class/services/AuthService';

// Компонент для відображення картки перемоги
const BestWinCard = ({ imageSrc, providerName, winAmount,username }) => (
  <div className="carousel-item">
    <div className="col-4">
      <div className="card">
        <div className="card-img">
          <img src={imageSrc} alt={providerName} className="img-fluid" loading="lazy" />
        </div>
        <div className="CasinoGameCard_info CasinoGameCard_withProvider">
          <div className="CasinoGameCard_provider">
          { /*  <img alt="Providers name" src={providerIcon} className="CasinoGameCard_icon"  /> */}
            <p className="CasinoGameCard_name">{providerName}</p>
          </div>
          <p className="CasinoGameCard_gameName">{username}</p>
        </div>
        <h3 className="best-win"><strong>{winAmount}</strong></h3>
      </div>
    </div>
  </div>
);

const BestWinsSlider = ({selection}) => {
  const carouselRef = useRef(null);
  const [bestWins, setBestWins] = useState([]); 
  const [isLoading, setIsLoading] = useState(true); 

  if (selection == undefined) {
    selection = '';
  }

  
  useEffect(() => {
    Games.getBestWin(selection, AuthService.getCustom('currency'))
      .then((data) => {
        if (data.status == "ok") {
          setBestWins(data.params.best_wins);
        } else {
          setBestWins([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching best wins:', error);
        setBestWins([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);


  useEffect(() => {
    if (!carouselRef.current) return;
  
    const bootstrap = require('bootstrap'); // import Bootstrap
    const carousel = new bootstrap.Carousel(carouselRef.current, {
      interval: 3000, 
      ride: 'carousel',
    });
  
    return () => carousel.dispose(); 
  }, [bestWins]);
  

  // Ініціалізація слайдера
  useEffect(() => {
    if (bestWins.length === 0 || !carouselRef.current) return;

    const items = carouselRef.current.querySelectorAll('.carousel-item');

    if (items.length > 0) {
      items[0].classList.add('active'); // Робимо перший елемент активним
    }

    const minPerSlide = 3;

    // Клонування елементів для циклічного відображення
    items.forEach((el) => {
      let next = el.nextElementSibling;
      for (let i = 1; i < minPerSlide; i++) {
        if (!next) {
          next = items[0]; // wrap carousel by using first child
        }
        const cloneChild = next.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        next = next.nextElementSibling;
      }
    });
  }, [bestWins]); // Виконується тільки після оновлення bestWins!!!!!!!!!!!!!!!!

  if (!isLoading && bestWins.length === 0) {
    return null; // Якщо даних немає, нічого не рендеримо!!!!!!!!!!
  }

  if (!isLoading && bestWins.length < 3) {
    return null; // Якщо менше 3-х перемог — теж нічого не рендеримо
  }

  return (
    <div className="box-best-win-complete">
      <div className="body main-layout-item best-win-title ColumnSection_list">
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">
              <a href="#" className="HomeSection_header">
                <img alt="Best Win" src="/assets/img/icon-section/best-win.png" className="HomeSection_icon" />
                <div className="HomeSection_label">Best Win</div>
                <div className="HomeSection_right"></div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="justify-content-center multi-slider-box">
        <div
              id="recipeCarousel"
              className="multi-slider carousel slide"
              data-bs-ride="carousel" 
              data-bs-interval="3000" 
              ref={carouselRef}
        >
          <div className="carousel-inner" role="listbox">
            {bestWins.map((win, index) => (
              <BestWinCard
                key={index}
                imageSrc={win.game_image}
                providerName={win.game_name}
                username={win.username}
                winAmount={win.amount}
              />
            ))}
          </div>


        </div>
      </div>
    </div>
  );
};

export default BestWinsSlider;
